var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanoPrivado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicios",
    clipPath: "url(#clip0_781_6965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 30.0003L33.3333 35.0003H16.6667L20 30.0003M36.6667 20.0003H13.3333C13.3333 22.6525 14.3869 25.196 16.2623 27.0714C18.1376 28.9468 20.6812 30.0003 23.3333 30.0003H26.6667C29.2551 30.0021 31.7434 29.0002 33.6084 27.2052C35.4733 25.4102 36.5696 22.962 36.6667 20.3753V20.0003ZM13.3333 23.3337H5V6.66699H13.3333V23.3337Z",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6667 17.5V16.1111C21.6667 15.3744 21.9594 14.6679 22.4803 14.1469C23.0013 13.626 23.7078 13.3333 24.4445 13.3333H27.2223C27.959 13.3333 28.6656 13.626 29.1865 14.1469C29.7074 14.6679 30.0001 15.3744 30.0001 16.1111V17.5M23.0555 7.77778C23.0555 8.51449 23.3482 9.22103 23.8691 9.74196C24.39 10.2629 25.0966 10.5556 25.8333 10.5556C26.57 10.5556 27.2765 10.2629 27.7975 9.74196C28.3184 9.22103 28.6111 8.51449 28.6111 7.77778C28.6111 7.04107 28.3184 6.33453 27.7975 5.81359C27.2765 5.29266 26.57 5 25.8333 5C25.0966 5 24.39 5.29266 23.8691 5.81359C23.3482 6.33453 23.0555 7.04107 23.0555 7.77778Z",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_6965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanoPrivado);
export default __webpack_public_path__ + "static/media/banoPrivado.775b14c4c6d94966f91a53ef3ce5b4ad.svg";
export { ForwardRef as ReactComponent };